function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null);

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "cta_arrow");

var _ref3 =
/*#__PURE__*/
React.createElement("polyline", {
  className: "cls-1",
  points: "18.34 1.55 23.84 7.05 18.34 12.55"
});

var _ref4 =
/*#__PURE__*/
React.createElement("line", {
  className: "cls-1",
  x1: 24.17,
  y1: 7.05,
  x2: 1.13,
  y2: 7.05
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 26.04 13.97"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/cta_arrow.a6955848.svg";
export { SvgComponent as ReactComponent };